import AxiosHelperMyCampus from "./AxiosHelperMyCampus";

export default class RaumResResourceQr {

    static load(queryData) {
        return AxiosHelperMyCampus.get("/api/resourceqr/load", queryData);
    }
}
